import React from 'react'
import { ReactComponent as DockIcon } from 'assets/icons/dock.svg'
import { ReactComponent as MessageIcon } from 'assets/icons/message.svg'
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg'
import { APPLICATION_DOCUMENTS_MAX } from '../../../constants/applicationDocuments'
import s from './Overview.module.scss'

const safeNumber = value => {
	const n = Number(value)
	return Number.isNaN(n) ? 0 : n
}

const Overview = ({ row, onGenerateLor }) => {
	const docsFulfilled = safeNumber(row?.documentsCount)
	const docsMissing = safeNumber(row?.missingDocuments)
	// The required set is resolved per student - the baseline plus whatever the
	// courses they applied to require - so the denominator comes from the API.
	// A fixed constant here read "0 / 11" beside "Missing 15".
	const docsTotal =
		safeNumber(row?.documentsTotal) || docsFulfilled + docsMissing || APPLICATION_DOCUMENTS_MAX
	const docsNew = safeNumber(row?.newDocumentsCount)
	const lorCount = safeNumber(row?.lorRequestsCount)
	const bragExists = Boolean(row?.bragSheetExists)

	return (
		<section className={s.wrap}>
			<header className={s.header}>
				<h4 className={s.header__title}>Documents</h4>
				<span className={s.header__count}>{docsFulfilled}</span>
			</header>

			<div className={s.list}>
				<div className={s.item}>
					<div className={s.body}>
						<span className={s.icon}>
							<DockIcon />
						</span>
						<div className={s.inner}>
							<h4 className={s.title}>Documents</h4>
							<p className={s.meta}>
								<span className={s.metaItem}>Missing {docsMissing}</span>
								<span className={s.metaDot} aria-hidden="true">
									•
								</span>
								<span className={s.metaItem}>New {docsNew}</span>
							</p>
						</div>
						<span className={s.summary}>
							{docsFulfilled} / {docsTotal}
						</span>
					</div>
				</div>

				<div className={s.item}>
					<div className={s.body}>
						<span className={s.icon}>
							<MessageIcon />
						</span>
						<div className={s.inner}>
							<h4 className={s.title}>Brag Sheet</h4>
						</div>
						<span className={s.summary}>
							{bragExists ? 'Present' : 'Missing'}
						</span>
					</div>
				</div>

				<div className={s.item}>
					<div className={s.lorBlock}>
						<div className={s.body}>
							<span className={s.icon}>
								<MessageIcon />
							</span>
							<div className={s.inner}>
								<h4 className={s.title}>LoRs</h4>
							</div>
							<span className={s.summary}>{lorCount}</span>
						</div>
						<button
							type="button"
							className={s.create}
							onClick={() => onGenerateLor?.(row)}
						>
							<PlusIcon aria-hidden />
							Create LoR
						</button>
					</div>
				</div>
			</div>
		</section>
	)
}

export default Overview
